<script lang="ts">
	import { trackAction } from '$lib/tracking';
	import Icon from '@components/Icon.svelte';
	import LeftCondensed from '@icons/LeftCondensed.svelte';
	import RightCondensed from '@icons/RightCondensed.svelte';
	import { createEventDispatcher } from 'svelte';
	export let direction: 'back' | 'forward';
	export let hidden = false;

	const dispatch = createEventDispatcher();

	function handleClick() {
		trackAction('content', 'button', direction === 'back' ? 'Vorherige Seite' : 'Nächste Seite');
		dispatch('click');
	}

	let iconComponent = direction === 'back' ? LeftCondensed : RightCondensed;
</script>

<button
	type="button"
	class="w-8 md:w-13.5 flex items-center {direction === 'back' ? 'justify-end' : 'justify-start'}"
	class:invisible={hidden}
	on:click={handleClick}
	disabled={hidden}
	title={direction === 'back' ? 'Zurück' : 'Vor'}
	{...$$restProps}
>
	<Icon component={iconComponent} />
</button>
